module.exports = __webpack_public_path__ + "static/media/gridViewActiveIcon.3d2fa77d.png";